import React, { useCallback, useMemo } from "react";
import { Col, Row, Radio } from "antd";
import * as R from "ramda";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import * as gtag from "../../../../../lib/gtag";

const StyledRow = styled(Row)`
  width: 100%;
`;

const StyledRadio = styled(Radio)`
  width: 100%;
`;

const StyledRadioGroup = styled(Radio.Group)`
  padding: 0 42px;
  width: 100%;
`;

const Label = styled.span`
  display: inline-flex;
  flex-direction: column;
`;

const CandidatesType = styled.span`
  color: ${({ theme }) => theme["@gray-80"]};
  font-size: 12px;
  font-weight: 500;
`;

const CandidatesAmount = styled.span`
  color: ${({ theme }) => theme["@gray-60"]};
  font-size: 24px;
`;

function SourceFilter({ loading, metadata, onChange, value }) {
  const { t } = useTranslation();
  const candidatesCount = useMemo(
    () => [
      {
        amount: R.propOr(0, "total", metadata),
        optionValue: "",
        type: "all"
      },
      {
        amount: R.propOr(0, "registered", metadata),
        optionValue: "true",
        type: "internal"
      },
      {
        amount: R.propOr(0, "external", metadata),
        optionValue: "false",
        type: "external"
      }
    ],
    [metadata]
  );
  const handleChange = useCallback(
    event => {
      const value =
        event.target.value === ""
          ? "showAll"
          : event.target.value === "true"
          ? "showRegistered"
          : "showExternal";
      gtag.event({
        category: "VacancyCandidates",
        action: value
      });
      onChange(event.target.value);
    },
    [onChange]
  );
  return (
    <StyledRadioGroup disabled={loading} onChange={handleChange} value={value}>
      <StyledRow align="top" style={{ height: "100%" }} type="flex">
        {candidatesCount.map(({ amount, optionValue, type }) => (
          <Col key={type} span={8}>
            <StyledRadio
              data-test={`sources-filter-${type}`}
              value={optionValue}
            >
              <Label>
                <CandidatesType>
                  {t(`components:SourceFilter.${type}`)}
                </CandidatesType>
                <CandidatesAmount data-test={`candidates-amount-${type}`}>
                  {amount}
                </CandidatesAmount>
              </Label>
            </StyledRadio>
          </Col>
        ))}
      </StyledRow>
    </StyledRadioGroup>
  );
}

export default SourceFilter;
